import { SbEditableBlok } from '@storyblok/storyblok-editable'
import { richtextToPlainText } from '../../lib/utils/richtextToText'
import { GlossaryListBlok } from './types'

/** The terms of the GlossaryList blocks among a page's blocks, with their definitions as plain text. */
export const getGlossaryTerms = (bloks?: SbEditableBlok[]): Array<{ name: string; description: string }> =>
  (bloks ?? [])
    .filter((blok): blok is GlossaryListBlok => blok.component === 'GlossaryList')
    .flatMap(blok => blok.glossaryItem ?? [])
    .filter(item => item.headline)
    .map(item => ({ name: item.headline, description: richtextToPlainText(item.description) }))
